import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'


import { allReducer } from './reducers/allReducers'
import { cartReducer } from './reducers/cartReducer'

const reducers = combineReducers({
  all: allReducer,
  cart: cartReducer,
})

const initialState = {

}

const middlewares = [thunk]

const store = createStore(reducers, initialState, composeWithDevTools(applyMiddleware(...middlewares)))

export default store